const myHTTPResponseStatusCodes = {
    BAD_REQUEST: 400,
    UNPROCESSABLE_ENTITY: 422
}

export default myHTTPResponseStatusCodes;